import { CSSPlugin } from "gsap/CSSPlugin";
import { gsap } from "gsap/gsap-core";
import { documentReady } from "@sazka/utils/document-ready";
import { TimeoutTimer } from "@sazka/utils/timer";

gsap.registerPlugin(CSSPlugin);

const promoCardsSelectors = {
    root: ".js-ds-promo-card",
    item: ".js-ds-promo-card-item",
    dot: ".js-ds-promo-card-dot",
};

const promoCardsClasses = {
    itemActiveSelectorClass: "js-ds-promo-card-item-active",
    itemActiveStyleClass: "ds-promo-card__inner--active",
};

const initPromoCardCarousel = (rootElement: HTMLElement) => {
    const items: HTMLElement[] = [...rootElement.querySelectorAll(promoCardsSelectors.item)] as HTMLElement[];
    const dots: HTMLElement[] = [...rootElement.querySelectorAll(promoCardsSelectors.dot)] as HTMLElement[];

    const carouselSlideDuration = parseInt(rootElement.dataset.carouselSlideDuration) || 6;
    let timeout: TimeoutTimer, dotTween: gsap.core.Tween, isPaused: boolean;

    const timeoutDuration = carouselSlideDuration * 1000;

    const tweenOptions: gsap.TweenVars = {
        height: "100%",
        duration: carouselSlideDuration,
        ease: "linear",
    };

    const getCurrentIndex = () =>
        items.findIndex((item) => item.classList.contains(promoCardsClasses.itemActiveSelectorClass));

    const getNextIndex = () => {
        const current = getCurrentIndex();
        return current === items.length - 1 ? 0 : current + 1;
    };

    const goToIndex = (index: number) => {
        const current = getCurrentIndex();

        if (current === index) return;

        // Reset
        timeout?.clear();
        dotTween?.kill();
        gsap.set(dots[current].querySelector("span"), { height: 0 });

        items[current].classList.remove(promoCardsClasses.itemActiveStyleClass);
        items[current].classList.remove(promoCardsClasses.itemActiveSelectorClass);
        items[index].classList.add(promoCardsClasses.itemActiveStyleClass);
        items[index].classList.add(promoCardsClasses.itemActiveSelectorClass);

        // Animate
        dotTween = gsap.to(dots[index].querySelector("span"), tweenOptions);

        // eslint-disable-next-line no-use-before-define, @typescript-eslint/no-use-before-define
        timeout = new TimeoutTimer(timeoutCallback, timeoutDuration);

        if (isPaused) {
            timeout.pause();
            dotTween.pause();
        }
    };

    const timeoutCallback = () => {
        const nextIndex = getNextIndex();
        goToIndex(nextIndex);
    };

    dotTween = gsap.to(dots[getCurrentIndex()].querySelector("span"), tweenOptions);
    timeout = new TimeoutTimer(timeoutCallback, timeoutDuration);

    rootElement.addEventListener("mouseenter", () => {
        timeout.pause();
        dotTween.pause();
        isPaused = true;
    });

    rootElement.addEventListener("mouseleave", () => {
        timeout.resume();
        dotTween.resume();
        isPaused = false;
    });

    dots.forEach((dot, index) => {
        dot.addEventListener("click", () => goToIndex(index));
    });
};

const initPromoCards = () => {
    const cards: HTMLElement[] = [...document.querySelectorAll(promoCardsSelectors.root)] as HTMLElement[];

    cards.forEach(initPromoCardCarousel);
};

documentReady(initPromoCards);
